module.exports = "/images/SADNESS.png?012f313e345211fd36a3731d0f4f3008";